import UserManagementListing from "../../Components/UserManagement/UsermanagementListing";

export default function UserManagementListings() {
    return (
        <UserManagementListing />
    )
}